module.exports = __webpack_public_path__ + "components/media-kit/static/icon-australasia-f7b5c978cf3bd930da2e7b3ca4d965e4.svg";